import Loadable from '../../components/loadable';

const ContactAttendanceChart = Loadable({
  loader: () => import('../../pages/contacts/contact_attendance_chart'),
  type: 'block',
});

angular.module('gym').value('ContactAttendanceChart', ContactAttendanceChart);
